// Component: Alert
// Author: Vijay Radhakrishnan
import * as React from 'react';
import AlertNPM from '@rotaryintl/component-alert';
import WBRString from '@component/WbrString';

// comment
export default function Alert(props) {
  let Variant = 'info';

  if (props.fields?.Variant?.value !== '') {
    Variant = props.fields?.Variant?.value.toLowerCase();
  }

  let Text = '';
  Text = (
    <>
      <WBRString tag="span">{props.fields?.Text?.value}</WBRString>
    </>
  );

  /**
   * TODO: When Web Commons team renames canDismiss to IsDismissible,
   * we need to rename the parameter below
   */
  return (
    <>
      <AlertNPM canDismiss={props.fields?.IsDismissible?.value} text={Text} variant={Variant} />
    </>
  );
}
